<h1 mat-dialog-title>{{title}}</h1>
<div mat-dialog-content>
  <p>{{text}}</p>
  <mat-form-field class="full-width">
    <input matInput placeholder="Email" [(ngModel)]="email">
  </mat-form-field>


    <ng-container *ngIf="!isLoadingCompanies; else loading">
      <mat-form-field>
        <mat-select [(ngModel)]="company">
          <mat-option *ngFor="let cmp of companies" [value]="cmp" [ngStyle]="{'color': (cmp.archived) ? 'red' : 'black'}" >{{ cmp.name }}</mat-option>
        </mat-select>
      </mat-form-field>
    </ng-container>
    <ng-template #loading>
      <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    </ng-template>


</div>
<div mat-dialog-actions align="end">
  <button mat-raised-button (click)="onNoClick()" cdkFocusInitial color="primary">Cancel</button>
  <button mat-raised-button (click)="onYesClick()" readonly="" color="accent" [disabled]="false">Confirm</button>
</div>
